import React from 'react';
import { Box, FormControlLabel, Switch, TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {
	LocalizationProvider,
	MobileDateTimePicker,
} from '@mui/x-date-pickers';
import {
	CommentFormState,
	CommentFormStateErrors,
} from '../../hooks/useCommentEditorForm';

interface ActivityDetailsProps {
	formState: CommentFormState;
	handleChange: <T extends keyof CommentFormState>(
		field: T,
		value: CommentFormState[T],
		validate?: boolean,
	) => void;
	errors: CommentFormStateErrors;
}
const ActivityTime: React.FC<ActivityDetailsProps> = (props) => {
	const { formState, handleChange, errors } = props;

	const handleTimeChange = (
		type: 'regularTime' | 'overTime',
		input: string,
	): void => {
		const trimmedValue = input.substring(0, 5);
		const regex = /^\d*\.?\d{0,2}$/;

		if (trimmedValue === '' || regex.test(trimmedValue)) {
			const parsedValue = parseFloat(trimmedValue);
			handleChange('time', {
				...formState.time,
				[type]: parsedValue,
			} as CommentFormState['time']);
		}
	};

	const timeErrors = JSON.parse(errors.time || '{}'); // errors.time is a stringified object of time regularTime and overTime. Check validateRegularAndOverTime function for more details

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: { xs: 'column', md: 'row' },
				gap: 1,
				alignItems: { md: 'center' },
			}}
		>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<MobileDateTimePicker
					value={formState.entryDate || null}
					onChange={(newDate) =>
						newDate ? handleChange('entryDate', newDate) : null
					}
					label="Entry Date"
					inputFormat="MMM dd, hh:mm a"
					renderInput={(params) => (
						<TextField {...params} fullWidth />
					)}
				/>
			</LocalizationProvider>
			<Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
				<TextField
					type="number"
					value={formState.time.regularTime}
					onChange={(e) => {
						handleTimeChange('regularTime', e.target.value);
					}}
					error={!!timeErrors?.regularTime}
					helperText={timeErrors?.regularTime}
					label="Regular Time"
					variant="outlined"
					sx={{ minWidth: '100px', flex: 1 }}
					inputProps={{ step: 0.25 }} // increment by 0.25 or 15 minutes
				/>
				<TextField
					type="number"
					value={formState.time.overTime}
					onChange={(e) => {
						handleTimeChange('overTime', e.target.value);
					}}
					error={!!timeErrors?.overTime}
					helperText={timeErrors?.overTime}
					label="Overtime Time"
					variant="outlined"
					sx={{ minWidth: '100px', flex: 1 }}
					inputProps={{ step: 0.25 }} // increment by 0.25 or 15 minutes
				/>
			</Box>
			<FormControlLabel
				control={
					<Switch
						checked={formState.billable}
						onChange={(e) => handleChange('billable', e.target.checked)}
						color="primary"
					/>
				}
				label="Billable"
				sx={{ ml: { xs: 0, md: 1 }, minWidth: 'fit-content' }}
			/>
		</Box>
	);
};
export default ActivityTime;
